import type { PathConfig } from '@react-navigation/native';
import { groupMembersLinking } from 'app/screens/groups/group-members.linking';
import type { Parameters } from './navigator';

export const linking: PathConfig<Parameters> = {
  path: '/management',
  screens: {
    'management-overview': '/overview',
    'my-address': '/my-address/:id',
    'my-loans': '/my-loans',
    'my-listings': {
      path: '/my-listings',
      parse: { type: String },
      stringify: { type: String },
    },
    'neighbour-profile': '/neighbour',
    'neighbour-listings': '/neighbour-listings',
    'one-channel': '/chat/:url',
    'one-listing': '/:id',
    'listing-activity': '/activity/:listingId',
    ratings: '/ratings',
    'one-loan': '/loans',
    'loan-participants': 'loans/:loanId/participants',
    'past-loans': '/past-loans',
    favourites: '/favourites',
    'group-members': groupMembersLinking,
    'loan-dates-picker': '/loans/:id/dates',
  },
};
